
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import './styles.scss'
import '../../styles/index.scss'

class TextArea extends Component {
  onChange (name, value) {
    this.props.Store.updateFieldValue(name, value)
    const { onChangeValidationFunction = [] } = this.props
    let isValid = true
    onChangeValidationFunction.forEach(funct => {
      if (!funct(name, value)) isValid = false
    })
    this.props.Store.updateFieldError(name, !isValid)
  }

  onKeyPress (e) {
    const { onKeyPressValidationFunction = [] } = this.props
    onKeyPressValidationFunction.forEach(funct => {
      funct(e)
    })
  }

  render () {
    const { name, placeholder, className, rows, automationName, Store } = this.props
    return (
      <textarea
        id={`${name}_ID`}
        className={`${className}`}
        name={name}
        value={Store.getValue(name)}
        placeholder={placeholder}
        rows={rows}
        onChange={(e) => { this.onChange(name, e.target.value) }}
        onKeyPress={(e) => { this.onKeyPress(e) }}
        data-automation-name={automationName}
      />
    )
  }
}

export default observer(TextArea)
